<template>
  <div class="main" :style="styleObj">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    bgImgUrl: String,
    bgColor: {
      type: String,
      required: true
    }
  },
  computed: {
    styleObj() {
      if (this.bgImgUrl) {
        return {
          background: `center top / 100% no-repeat url("${this.bgImgUrl}") ${this.bgColor}`
        };
      }
      return {
        backgroundColor: this.bgColor
      };
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 1220px;
}
</style>
